import { MaestroPdf } from "@components/reports/SavePdf";
import { pdf } from "@react-pdf/renderer";

const mockProps = {
    reportInfo: {
        communityName: '',
        name: '',
        author: '',
        description: '',
        statsOnly: false,
    },
    report: {
        //
    },
};

const getReportPdfBlob = (props) => {
    const finalProps = {
      ...mockProps,
      ...props,
    };

    return pdf(<MaestroPdf {...finalProps} />).toBlob();
  }

  export {getReportPdfBlob};
